export const propertiesForRent = [
  {
    id: 'rent-1',
    title: 'Flat in Dubai Marina',
    price: 'AED 155,000',
    location: 'Elite Residence, Dubai Marina',
    beds: 1,
    baths: 1,
    sqft: '1,329.34',
    img: '/images/properties/edward_dubai_marina.jpg',
    images: [
      '/images/properties/edward_gallery/elite-residence_GVmzz_xl.jpg',
      '/images/properties/edward_gallery/Dubai Marina for rent.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.38 AM.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.39 AM.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.40 AM.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.41 AM.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.42 AM.jpeg',
      '/images/properties/edward_gallery/WhatsApp Image 2025-10-09 at 4.55.43 AM.jpeg'
    ],
    type: 'Flat',
    furnished: true,
    description: 'This beautifully located flat in Dubai Marina is available for rent. With stunning views and proximity to key amenities, it offers an incredible living experience. The property is ready for immediate occupancy.',
    owner: 'Edward',
    availability: 'Vacant',
    nocSigned: 'Yes',
    cheques: '1'
  },
  {
    id: 'rent-2',
    title: 'Flat in Al Barsha South Fourth',
    price: 'AED 85,000/year',
    location: 'Binghatti Mirage, Al Barsha South Fourth',
    beds: 1,
    baths: 1,
    sqft: '632.7',
    img: '/images/properties/julius_apartment.jpeg',
    images: [
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.21 AM.jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.21 AM (1).jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.21 AM (2).jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.22 AM.jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.22 AM (1).jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.22 AM (2).jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.23 AM.jpeg',
      '/images/properties/julius_gallery/WhatsApp Image 2025-10-08 at 4.15.24 AM.jpeg'
    ],
    type: 'Flat',
    furnished: false,
    description: 'This cozy flat is now available for rent in the prestigious Binghatti Mirage, Al Barsha South Fourth. Ideal for singles or couples, this one-bedroom apartment offers spacious living and modern amenities.',
    owner: 'Julius',
    availability: 'Vacant',
    nocSigned: 'Yes'
  }
];

export const propertiesForSale = [
  {
    id: 'sale-1',
    title: 'Studio in Wadi Al Safa 7',
    price: 'AED 1,200,000',
    location: 'Rukan - Building B, Wadi Al Safa 7',
    beds: 0,
    baths: 1,
    sqft: '354.34',
    img: '/images/properties/rukan_studio_new.avif',
    type: 'Studio',
    description: 'This studio apartment in the vibrant Wadi Al Safa 7 is a perfect investment for first-time buyers. The property offers modern finishes, spacious interiors, and a community that fosters both comfort and convenience. With easy access to schools, parks, and shopping areas, it is perfect for young professionals or small families.',
    owner: 'Hessa',
    availability: 'Vacant',
    nocSigned: 'Yes'
  },
  {
    id: 'sale-2',
    title: '1-BHK in JVC',
    price: 'AED 1,000,000',
    location: 'Vita Grande By Meteora, JVC',
    beds: 1,
    baths: 1,
    sqft: '648.52',
    img: '/images/properties/jvc_apartment_new.avif',
    type: '1-BHK',
    description: 'This one-bedroom apartment in the lively Jumeirah Village Circle (JVC) is a perfect opportunity for anyone looking to own property in a thriving neighborhood. With easy access to shopping malls, cafes, and public transport, this flat offers a convenient and stylish living experience.',
    owner: 'Julius',
    availability: 'Vacant',
    nocSigned: 'Yes'
  },
  {
    id: 'sale-3',
    title: '1-BHK in JLT',
    price: 'AED 1,600,000',
    location: 'Greenlakes Tower, JLT',
    beds: 1,
    baths: 1,
    sqft: '1,085',
    img: '/images/properties/jlt_apartment_new.webp',
    type: '1-BHK',
    description: 'This spacious one-bedroom apartment is located in the desirable Greenlakes Tower in JLT, an area well-known for its blend of residential comfort and business convenience. While this property has been sold, its appeal remains as a model for JLT living.',
    owner: 'Melissa',
    availability: 'Sold',
    nocSigned: 'Yes'
  },
  {
    id: 'sale-4',
    title: '2-BHK in Al Jadaf',
    price: 'AED 1,500,000 (negotiable)',
    location: 'Binghatti Avenue, Al Jadaf',
    beds: 2,
    baths: 2,
    sqft: '9,615.4',
    img: '/images/properties/al_jadaf_apartment_new.avif',
    type: '2-BHK',
    description: 'A luxurious two-bedroom apartment situated in the highly sought-after Binghatti Avenue. It features large living spaces, modern interiors, and a well-established community. Located near top schools, healthcare facilities, and the metro station, it is ideal for families looking to live in a vibrant area.',
    owner: 'Sara',
    availability: 'Vacant',
    nocSigned: 'Yes'
  },
  {
    id: 'sale-5',
    title: 'Office in Business Bay',
    price: 'AED 1,100,000',
    location: 'Park Lane, Business Bay',
    beds: 0,
    baths: 1,
    sqft: '669.08',
    img: '/images/properties/business_bay_office_new.jpg',
    type: 'Office',
    description: 'This office space in the heart of Business Bay is ideal for entrepreneurs and small businesses looking for a prime location. With access to major roads, transportation hubs, and business districts, it’s a perfect place to grow your business and increase your exposure.',
    owner: 'Zakir',
    availability: 'Vacant',
    nocSigned: 'Yes'
  }
];
